import { Component, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslatePipe } from "@skylab-angular-shared/pipes";
import { ButtonComponent, SelectValueAccessorDirective, TextValueAccessorDirective, ValidateDirective, ValidateInnerDirective, ValidationSourceDirective } from "@skylab-angular-shared/ui";
import { ClientDialogFormComponent } from "./client-dialog-form.component";

@Component({
    selector: 'skl-client-dialog-other-buyer-form',
    template: `
        @if (ready()) {
            <div class="grid" [sklValidationSource]="viewValidation!">
                <div class="col-1-3">
                    <ins-form-field
                        [label]="'scenes.shared.dialog.client.form.fields.client-kind.label' | translate">
                        <ins-select
                            [id]="getElementId('client-dialog-kind')"
                            display-text="label"
                            [readonly]="previousDataMode() || previewMode() || adjustmentMode()"
                            [converter]="clientKindValueConverter"
                            [(ngModel)]="bo().model.kind"
                            [sklValidate]="getValidationKey('kind')">
                            @for (item of clientKinds; track item) {
                                <ins-option
                                    [value]="item">
                                    {{item.label}}
                                </ins-option>
                            }
                        </ins-select>
                    </ins-form-field>
                </div>
                <div class="col-2-3">
                    <div class="input-button-wrapper">
                        <ins-form-field
                            [label]="(isCompany() ? 'scenes.shared.dialog.client.form.fields.name.label-company' : 'scenes.shared.dialog.client.form.fields.name.label-person') | translate">
                            <ins-input
                                [id]="getElementId('client-dialog-name')"
                                [readonly]="previousDataMode() || previewMode()!"
                                [(ngModel)]="bo().model.name"
                                [placeholder]="(isCompany() ? 'scenes.shared.dialog.client.form.fields.name.placeholder-company' : 'scenes.shared.dialog.client.form.fields.name.placeholder-person') | translate"
                                [sklValidate]="getValidationKey('name')">
                            </ins-input>
                        </ins-form-field>
                        @let msg = goToMessage();
                        @if (msg) {
                            <skl-button
                                (click)="redirectToClients.emit()"
                                [tooltip]="msg"
                                typeName="primary"
                                [sklValidateInner]="{key: getValidationKey('name'), option: 'hide'}"
                                [sklValidateInnerReadonly]="previousDataMode() || previewMode()!">
                                {{ 'scenes.shared.dialog.client.buttons.repair' | translate }}
                            </skl-button>
                        }
                    </div>
                </div>
                <div class="col-1">
                    <div class="col-1-3">
                        <ins-form-field
                            class="text-truncate"
                            [label]="'scenes.shared.dialog.client.form.fields.tin-kind.label' | translate">
                            <ins-select
                                [id]="getElementId('client-form-tin-kind')"
                                display-text="label"
                                [placeholder]="'ui.placeholders.empty' | translate"
                                [readonly]="previousDataMode() || previewMode() || adjustmentMode()"
                                [converter]="tinKindValueConverter"
                                [(ngModel)]="bo().model.tinKind"
                                [sklValidate]="getValidationKey('tinKind')">
                                @for (item of tinKinds; track item) {
                                    <ins-option
                                        [value]="item">
                                        {{item.label}}
                                    </ins-option>
                                }
                            </ins-select>
                        </ins-form-field>
                    </div>
                    <div class="col-2-3">
                        <div class="input-button-wrapper">
                            @let tinKindLabel = tinKindValueConverter.convert(bo().model.tinKind)?.label || '';
                            <ins-form-field
                                [label]="tinKindLabel">
                                <ins-input
                                    [id]="getElementId('client-dialog-tin')"
                                    [(ngModel)]="bo().model.tin"
                                    (insInput)="setGusSearchButtonDisabled($event)"
                                    [readonly]="previousDataMode() || previewMode() || adjustmentMode()"
                                    [placeholder]="'scenes.clients.form.fields.tax-identification-number.placeholder' | translate: { value: tinKindLabel }"
                                    [sklValidate]="getValidationKey('tin')">
                                </ins-input>
                            </ins-form-field>
                            @if (gusButtonVisible()) {
                                <skl-button
                                    class="align--big-top"
                                    [id]="getElementId('client-dialog-gus-searching-button')"
                                    typeName="primary"
                                    (click)="searchInGusAsync()"
                                    [disabled]="gusSearchButtonDisabled()"
                                    [spinner]="gusSearching()">
                                    {{ ('scenes.shared.dialog.client.form.buttons.search-in-gus.search') | translate }}
                                </skl-button>
                            }
                        </div>
                    </div>
                </div>
                <div class="col-1">
                    <ins-form-field
                        [label]="'scenes.shared.dialog.client.form.fields.address.label' | translate">
                        <ins-input
                            [id]="getElementId('client-dialog-address')"
                            [(ngModel)]="bo().model.address"
                            [readonly]="previousDataMode() || previewMode()!"
                            [placeholder]="'scenes.shared.dialog.client.form.fields.address.placeholder' | translate"
                            [sklValidate]="getValidationKey('address')">
                        </ins-input>
                    </ins-form-field>
                </div>
                <div class="col-1">
                    <div class="col-1-3">
                        <ins-form-field
                            [label]="'scenes.shared.dialog.client.form.fields.zip-code.label' | translate">
                            <ins-input
                                [id]="getElementId('client-dialog-zip-code')"
                                [(ngModel)]="bo().model.zipCode"
                                [readonly]="previousDataMode() || previewMode()!"
                                [placeholder]="'scenes.shared.dialog.client.form.fields.zip-code.placeholder' | translate"
                                [sklValidate]="getValidationKey('zipCode')">
                            </ins-input>
                        </ins-form-field>
                    </div>
                    <div class="col-1-3">
                        <ins-form-field
                            [label]="'scenes.shared.dialog.client.form.fields.city.label' | translate">
                            <ins-input
                                [id]="getElementId('client-dialog-city')"
                                [(ngModel)]="bo().model.city"
                                [readonly]="previousDataMode() || previewMode()!"
                                [placeholder]="'scenes.shared.dialog.client.form.fields.city.placeholder' | translate"
                                [sklValidate]="getValidationKey('city')">
                            </ins-input>
                        </ins-form-field>
                    </div>
                    <div class="col-1-3">
                        <ins-form-field
                            [label]="'scenes.shared.dialog.client.form.fields.country.label' | translate">
                            <ins-select
                                [id]="getElementId('client-dialog-country')"
                                display-text="name"
                                [converter]="countryValueConverter"
                                [readonly]="previousDataMode() || previewMode()!"
                                [(ngModel)]="bo().model.countryId"
                                [sklValidate]="getValidationKey('countryId')">
                                @for (item of countries(); track item) {
                                    <ins-option
                                        [value]="item">
                                        {{item.name}}
                                    </ins-option>
                                }
                            </ins-select>
                        </ins-form-field>
                    </div>
                </div>
            </div>
        }
    `,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [ValidateInnerDirective, ValidationSourceDirective, TextValueAccessorDirective, FormsModule, ValidateDirective, SelectValueAccessorDirective, TranslatePipe, ButtonComponent]
})
export class ClientDialogOtherBuyerFormComponent extends ClientDialogFormComponent {
    override getElementId(id: string): string {
        return `other-buyer-${this.previousDataMode() ? `previous-${id}` : id}`;
    }
}